import { useCreditCard } from "@/hooks/useCreditCard";
import { LockIcon } from "@/styles/icons/LockIcon";
import { useParams } from "react-router-dom";
import { showToast } from "@/utils";
import { Button, Modal } from "barte-design-system";
import { Text } from "@chakra-ui/react";

interface BlockCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
export default function BlockCreditCard({isOpen, onClose}: BlockCreditCardProps) {
    const {
        creditCardData,
        updateCardStatus,
        loading,
        setCreditCardData
    } = useCreditCard();
    const isBlocked = creditCardData?.cardStatus === "BLOCKED";
    const { id } = useParams();

    function formatCardStatus(value: string) {
        const status = {
          ACTIVE: "ativo",
          BLOCKED: "bloqueado"
        }
        return status[value] || value;
    }

    async function onSubmit() {
        try {
            const formatedCardStatus = isBlocked ? "ACTIVE" : "BLOCKED"
            await updateCardStatus(formatedCardStatus, id ?? creditCardData?.cardId);
            showToast({ type: "success", message: `Cartao ${formatCardStatus(formatedCardStatus)} com sucesso.` });
            setCreditCardData({ ...creditCardData, cardStatus: formatedCardStatus });
        } catch (error) {
            error?.response?.data?.errors.map((error) => {
                showToast({ type: "error", message: `${error?.code} - ${error?.description}` });
            });
        } finally {
            onClose();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            title={isBlocked ? "Desbloquear temporariamente o cartão" : "Bloquear temporariamente o cartão"}
            onClose={onClose}
            footer={{
                primaryButton: {
                    children: isBlocked ? "Desbloquear" : "Bloquear",
                    onClick: onSubmit,
                    loading,
                    disabled: loading,
                },
                secondaryButton: { children: "Cancelar", onClick: onClose, variant: "outline" },
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <LockIcon />
                <Text fontSize="14px">
                    {isBlocked ? "Você quer temporariamente desbloquear o cartão?" : "Você quer temporariamente bloquear o cartão?"}
                </Text>
                {!isBlocked && (
                    <Text fontSize="12px" color="#8A94A8">
                        Enquanto estiver bloqueado, seu cartão não aprovará nenhuma nova compra.
                    </Text>
                )}
            </div>
        </Modal>
    );
}
